'use strict';

class SuperMaintenanceController {
    constructor(SSUtilService, SSUserService, SSHttpService, OTPService, SSAlertService, SSConfirmationService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.OTPService = OTPService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.SYSTEM_SETTINGS_SMS_SERVICE = SHOWSUITE.SYSTEM_SETTINGS_SMS_SERVICE;

        // WEB-4732: no message request without the view key (the API answers 403004).
        if (self.canView()) {
            self.init();
        }
    }

    // ---- Permissions (WEB-4732, keys from WEB-4725; the main super user passes all) ----

    /** @returns {boolean} May open the page and see each environment's messages. */
    canView() {
        return this.SSUserService.isSuper() && this.SSUserService.hasPermission('SS_MAINTENANCE_MESSAGE_VIEW');
    }

    /** @returns {boolean} May edit and save the Maintenance and Updates messages. */
    canUpdate() {
        return this.SSUserService.hasPermission('SS_MAINTENANCE_MESSAGE_UPDATE');
    }

    init() {
        const self = this;
        self.entry = {};
        self.dateErrors = {};

        self.errUpdate_version = '';
        self.errUpdate_massage = '';
        self.errMaintenance_massage = '';

        self.edit_able_maintenance = false;
        self.edit_able_update = false;

        self.entry.maintenance_active = false;
        self.entry.update_active = false;

        //By Defalut IOS Environment Set
        self.environment = 'ios';

        self.selectedEnvironment(self.environment);

    }

    getenvironment(environment) {
        let self = this;

        self.environment = environment;

        let url = 'sec/super/maintenance/messages/' + environment;
        let data = {
            environment: environment,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, data).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.maintenanca_update = response.data;


            if (self.maintenanca_update[0]) {
                if (self.maintenanca_update[0]['active'] && self.maintenanca_update[0]['active'] != "false")
                    self.entry.maintenance_active = true;
                else
                    self.entry.maintenance_active = false;

                self.entry.maintenance_massage = self.maintenanca_update[0]['message'];



                self.entry.maintenance_start_at = self.SSUtilService.formatUtcToLocalDateTime(self.maintenanca_update[0]['start_at']);
                // self.entry.maintenance_start_at = moment(self.maintenanca_update[0]['start_at'], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
                self.entry.maintenance_end_at = self.SSUtilService.formatUtcToLocalDateTime(self.maintenanca_update[0]['end_at']);
                // self.entry.maintenance_end_at = moment(self.maintenanca_update[0]['end_at'], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");

            } else {
                self.entry.maintenance_active = false;
                self.entry.maintenance_massage = '';
                self.entry.maintenance_start_at = '';
                self.entry.maintenance_end_at = '';
            }

            if (self.maintenanca_update[1]) {

                if (self.maintenanca_update[1]['active'] && self.maintenanca_update[1]['active'] != "false")
                    self.entry.update_active = true;
                else
                    self.entry.update_active = false;

                self.entry.update_massage = self.maintenanca_update[1]['message'];
                self.entry.update_version = self.maintenanca_update[1]['version'];

                if (self.maintenanca_update[1]['force_update'] && self.maintenanca_update[1]['force_update'] != "false")
                    self.entry.update_force_update_check = true;
                else
                    self.entry.update_force_update_check = false;

            } else {
                self.entry.update_active = false;
                self.entry.update_massage = '';
                self.entry.update_version = '';
                self.entry.update_force_update_check = false;
            }

        });
    }

    selectedEnvironment(environment) {
        const self = this;

        self.show_maintenance_update = true;

        if (environment == 'ios') {
            self.getenvironment('ios');
            self.iso_color = 'primary';
            self.android_color = 'secondary';
            self.web_color = 'secondary';
            self.updateNotShow = true;

        } else if (environment == 'android') {
            self.getenvironment('android');
            self.iso_color = 'secondary';
            self.android_color = 'primary';
            self.web_color = 'secondary';
            self.updateNotShow = true;

        } else if (environment == 'web') {
            self.getenvironment('web');
            self.iso_color = 'secondary';
            self.android_color = 'secondary';
            self.web_color = 'primary';
            self.updateNotShow = false;
        }
    }


    editMaintenanceSettings(editMode) {
        const self = this;

        self.edit_able_maintenance = editMode;

        self.maintenanceEditMode = editMode;
    }

    editUpdateSettings(editMode) {
        const self = this;

        self.edit_able_update = editMode;

        self.updaetEditMode = editMode;
    }


    saveEnvironment(editMode,validate, environment) {
        const self = this;

        if (validate) {
            if (!self.isValidInput(environment))
                return;
        }

        let data = {};

        if(environment == 'update')
        {
            data = {
                //Required Field For Update
                type: 'update',
                active: self.entry.update_active,

                //Field Data
                message: self.entry.update_massage,
                version: self.entry.update_version,
                force_update: self.entry.update_force_update_check
            };
        }
        else {

            self.entry.maintenance_start_at = self.SSUtilService.formatLocalToUtc(self.entry.maintenance_start_at);
            // self.entry.maintenance_start_at = moment(self.entry.maintenance_start_at, "DD-MM-YYYY HH:mm:ss").format( "YYYY-MM-DD HH:mm:ss");
            self.entry.maintenance_end_at = self.SSUtilService.formatLocalToUtc(self.entry.maintenance_end_at);
            // self.entry.maintenance_end_at = moment(self.entry.maintenance_end_at, "DD-MM-YYYY HH:mm:ss").format( "YYYY-MM-DD HH:mm:ss");

            data = {
                //Required Field For Maintenance
                type: 'maintenance',
                active: self.entry.maintenance_active,

                //Field Data
                message: self.entry.maintenance_massage,
                start_at: self.entry.maintenance_start_at,
                end_at: self.entry.maintenance_end_at
            };

            if(self.entry.maintenance_start_at >= self.entry.maintenance_end_at)
            {
                self.SSAlertService.danger('Start Date must be smaller then End Date');
                return;
            }
        }

        let url = 'sec/super/maintenance/messages/' + self.environment;

        loading(true);

        self.SSHttpService.putAPIRequest(url, data).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            self.selectedEnvironment(self.environment);
        });


        if(environment == 'update')
        {
            self.edit_able_update = editMode;
            self.updaetEditMode = editMode;
        }
        else
        {
            self.edit_able_maintenance = editMode;
            self.maintenanceEditMode = editMode;
        }

    }


    isValidInput(environment) {
        const self = this;

        let isValid = true;

        self.errUpdate_version = '';
        self.errUpdate_massage = '';
        self.errMaintenance_massage = '';

        self.dateErrors = {};

        if (environment == 'update') {

            if (!self.entry.update_version) {
                self.errUpdate_version = "Please enter Version";
                isValid = false;
            }
            if (!self.entry.update_massage) {
                self.errUpdate_massage = "Please enter the Massage";
                isValid = false;
            }
        }
        else
        {
            if (self.entry.maintenance_start_at == "" || self.entry.maintenance_start_at == undefined) {
                self.dateErrors.start_at = "Please select Start Date";
                isValid = false;
            }
            if (self.entry.maintenance_end_at == "" || self.entry.maintenance_end_at == undefined) {
                self.dateErrors.end_at = "Please select End Date";
                isValid = false;
            }

            if (!self.entry.maintenance_massage) {
                self.errMaintenance_massage = "Please enter the Massage";
                isValid = false;
            }
        }

        return isValid;
    }

}

SuperMaintenanceController.$inject = ['SSUtilService', 'SSUserService', 'SSHttpService','OTPService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperMaintenanceController', SuperMaintenanceController);


app.directive("datetimepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            showTimePicker: false,
            showSecond:false,
            showMillisec:false,
            showMicrosec:false,
            showTimezone:false
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});